module.exports = __webpack_public_path__ + "img/5-1.1fecce8d.svg";